var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _c("span", {
      staticClass: "ld ld-ring ld-cycle input-loader",
      class: _vm.loaderClasses,
      style: _vm.loaderStyles,
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }